/*
 * Lecture du verdict pose par static/mobile-guard.js (charge en <script>
 * bloquant avant le bundle).
 *
 * Le recalcul en repli n'est pas defensif pour rien : en developpement le
 * garde est servi depuis static/ par le devServer, et un 404 sur ce fichier
 * passerait inapercu. Sans repli, le parcours mobile disparaitrait
 * silencieusement et on ne le verrait qu'en production.
 */
const MAX_WIDTH = 900;
const forcedDesktop = () => {
    try {
        return (/[?&]desktop=1/.test(window.location.search) ||
            window.sessionStorage.getItem('forastech.force3d') === '1');
    }
    catch (e) {
        return /[?&]desktop=1/.test(window.location.search);
    }
};
const detectSmallScreen = () => {
    if (typeof window.matchMedia !== 'function')
        return false;
    return (window.matchMedia(`(max-width: ${MAX_WIDTH}px)`).matches &&
        window.matchMedia('(pointer: coarse)').matches);
};
/**
 * true sur mobile et tablette : l'intro et la scene 3D jouent normalement,
 * mais le geste de depart emmene sur le site marketing au lieu d'entrer
 * dans la scene.
 */
export const isMobilePreview = () => {
    if (typeof window.FORASTECH_MOBILE_PREVIEW === 'boolean') {
        return window.FORASTECH_MOBILE_PREVIEW;
    }
    return !forcedDesktop() && detectSmallScreen();
};
/** URL du site marketing (dossier 2), ou null si elle n'a pas ete injectee. */
export const getSiteUrl = () => {
    if (typeof window.FORASTECH_SITE_URL === 'string') {
        return window.FORASTECH_SITE_URL;
    }
    const meta = document.querySelector('meta[name="forastech-site-url"]');
    const url = meta && meta.getAttribute('content');
    return url && url.indexOf('%') === -1 ? url : null;
};
